module.exports = __webpack_public_path__ + "img/7.f6d70f2d.jpg";